import { useQueryState, parseAsBoolean, useQueryStates, parseAsString } from 'nuqs';

export const usePleaseLogIn = () => useQueryState('pleaseLogIn', parseAsBoolean);
export const usePleaseLogInAndRedirect = () =>
  useQueryStates({
    pleaseLogIn: parseAsBoolean,
    pleaseLogInRedirect: parseAsString
  });
